module.exports = __webpack_public_path__ + "media/images/calderon_logo-6264297396b1066014506487666a89db.svg";